import {Injectable} from "@angular/core";
import {Observable} from "rxjs";

@Injectable({
	providedIn: "root"
})
export abstract class AbstractInitializer {
	public abstract initalize(config?: any): Observable<boolean>;
}